import { useEffect, useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { RequirementDetailPopupAdd } from "../../../../pages/gestionePersonale/boxRequisiti/boxPopupReqDetail/add";
import { RequirementDetailPopupEdit } from "../../../../pages/gestionePersonale/boxRequisiti/boxPopupReqDetail/edit";
import { RequirementDetailDTO } from "../../../../pages/gestionePersonale/boxRequisiti/dataService/dto";
import { RequirementDetailDelete, resetRequirementDetailCreationRequest, resetRequirementDetailDeleteStatus, resetRequirementDetailErrors, resetRequirementDetails, resetRequirementDetailUpdateRequest, setReqDetailPersonalManagementId, setReqDetailRequirementId, setRequirementDetailIdToUpdate, setUpdateReqDetailDetail, setUpdateReqDetailEnding, setUpdateReqDetailNote, setUpdateReqDetailProtocols, setUpdateReqDetailStarting } from "../../../../pages/gestionePersonale/boxRequisiti/slice";
import { GetByIdPersonalManagement } from "../../../../pages/gestionePersonale/slice";
import { formatterDate } from "../../../../utils";
import { EditIcon } from "../../../icons/edit";
import { TrashIcon } from "../../../icons/trash";
import { ButtonComponent } from "../../../molecules/button/newButton";
import { PopupForm } from "../../popupForm";

interface Props {
    details: RequirementDetailDTO[]
    requirementId: string
}

export function DetailTable(props: Props) {
    const { details, requirementId } = props
    const dispatch = useAppDispatch()
    const requirementState = useAppSelector(state => state.PMRequirement)
    const PMState = useAppSelector(state => state.personalManagement)
    const [addPopupShow, setAddPopupShow] = useState<boolean>(false)
    const [editPopupShow, setEditPopupShow] = useState<boolean>(false)

    const handleOnEdit = (rd: RequirementDetailDTO) => {
        dispatch(setUpdateReqDetailStarting(rd.starting))
        dispatch(setUpdateReqDetailEnding(rd.ending))
        dispatch(setUpdateReqDetailDetail(rd.detail))
        dispatch(setUpdateReqDetailProtocols(rd.protocols))
        dispatch(setUpdateReqDetailNote(rd.note))
        dispatch(setRequirementDetailIdToUpdate(rd.id))
        setEditPopupShow(true)
    }

    useEffect(() => {
        if (requirementState.requirementDetailDeleteStatus === 'successfully') {
            dispatch(resetRequirementDetailDeleteStatus())
            dispatch(resetRequirementDetails())
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!))
        }
    }, [requirementState.requirementDetailDeleteStatus])

    return (
        <Fragment>
            <div className="mt-4 w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                <table className="w-[100%] border-collapse text-sm">
                    <thead className="uppercase">
                        <tr className="h-[48px] bg-brandPrimary-600 text-white text-[12px] font-semibold leading-4 text-left">
                            <th className="rounded-tl-xl w-[10%] px-2 py-3 whitespace-nowrap">DAL</th>
                            <th className="w-[10%] px-2 py-3 whitespace-nowrap">AL</th>
                            <th className="w-[50%] px-2 py-3 whitespace-nowrap">DETTAGLI</th>
                            <th className="w-[20%] px-2 py-3 whitespace-nowrap">RIFERIMENTO PROTOCOLLI</th>
                            <th className="rounded-tr-xl w-[10%] px-2 py-3 whitespace-nowrap text-right">
                                <ButtonComponent
                                    size="sm"
                                    iconPosition="off"
                                    variant="outline"
                                    color="blue"
                                    label="Aggiungi nuovo"
                                    onClick={() => {
                                        dispatch(setReqDetailRequirementId(requirementId))
                                        dispatch(setReqDetailPersonalManagementId(PMState.currentPersonalManagementId))
                                        setAddPopupShow(true)
                                    }}
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            details.map((d, rowIndex) =>
                                <tr
                                    className={`${rowIndex % 2 === 0 ? 'bg-white' : 'bg-neutral-50'} hover:bg-brandPrimary-50 transition-colors duration-150 border-b border-neutral-200 text-sm font-normal leading-5 text-left text-gray-600`}
                                    key={d.id || `${d.requirementId}-${d.starting}-${rowIndex}`}
                                >
                                    <td className="px-2 py-2.5">{formatterDate(d.starting)}</td>
                                    <td className="px-2 py-2.5">{formatterDate(d.ending)}</td>
                                    <td className="px-2 py-2.5 max-w-[1000px]">{d.detail}</td>
                                    <td className="px-2 py-2.5">{d.protocols}</td>
                                    <td className="px-2 py-2.5">
                                        <div className="flex items-center gap-2 justify-end">
                                            <button className="w-8 h-8 border border-neutral-200 rounded-lg inline-flex items-center justify-center bg-white hover:bg-slate-50 hover:border-neutral-300 transition-colors duration-200" onClick={() => handleOnEdit(d)}>
                                                <EditIcon color='orange' size={20} />
                                            </button>
                                            <button className="w-8 h-8 border border-neutral-200 rounded-lg inline-flex items-center justify-center bg-white hover:bg-slate-50 hover:border-neutral-300 transition-colors duration-200" onClick={() => dispatch(RequirementDetailDelete(d.id!))}>
                                                <TrashIcon color='red' size={20} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
            {
                addPopupShow && (
                    <PopupForm title="Nuovo dettaglio requisito" close={() => {
                        dispatch(resetRequirementDetailCreationRequest())
                        dispatch(resetRequirementDetailErrors())
                        setAddPopupShow(false)
                    }}>
                        <RequirementDetailPopupAdd close={() => setAddPopupShow(false)} />
                    </PopupForm>
                )
            }
            {
                editPopupShow && (
                    <PopupForm title="Modifica dettaglio requisito" close={() => {
                        dispatch(resetRequirementDetailUpdateRequest())
                        dispatch(resetRequirementDetailErrors())
                        setEditPopupShow(false)
                    }}>
                        <RequirementDetailPopupEdit close={() => setEditPopupShow(false)} />
                    </PopupForm>
                )
            }
        </Fragment>
    )
}